import { motion } from "framer-motion";

const communes = [
  { name: "Montélimar", x: 350, y: 92 },
  { name: "Grignan", x: 322, y: 182 },
  { name: "Nyons", x: 566, y: 252 },
  { name: "Tulette", x: 292, y: 262 },
  { name: "Vaison-la-Romaine", x: 528, y: 348 },
  { name: "Bollène", x: 238, y: 332 },
  { name: "Visan", x: 330, y: 392 },
  { name: "St-Paul-Trois-Châteaux", x: 252, y: 436 },
  { name: "Orange", x: 348, y: 508 },
  { name: "Carpentras", x: 492, y: 508 },
];

export const Zone = () => (
  <section
    id="zone"
    className="px-6 md:px-12 py-32 md:py-48 border-t border-white/10 overflow-hidden"
    data-testid="zone-section"
  >
    <div className="grid md:grid-cols-2 gap-16 md:gap-24 items-center">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
      >
        <p className="text-xs uppercase tracking-[0.3em] text-gold mb-8">Zone d'intervention</p>
        <h2
          className="font-serif text-5xl md:text-7xl tracking-tighter leading-[0.95]"
          data-testid="zone-title"
        >
          valréas<br />
          <span className="italic font-light text-gold">& les alentours.</span>
        </h2>
        <p
          className="text-sm md:text-base text-ash font-light leading-relaxed mt-10 max-w-md"
          data-testid="zone-text"
        >
          Basés à Valréas, nous intervenons à domicile dans toutes les communes
          alentour : Nyons, Bollène, Vaison-la-Romaine, Orange, Grignan et bien
          d'autres. Les frais de déplacement sont calculés sur le devis, en
          fonction du nombre de kilomètres.
        </p>
        <p className="text-xs uppercase tracking-[0.25em] text-bone mt-10 border-l-2 border-gold pl-5">
          Devis personnalisé — déplacement calculé au kilomètre
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 1.2, ease: [0.76, 0, 0.24, 1] }}
        data-testid="zone-map"
      >
        <svg viewBox="0 0 800 600" className="w-full h-auto" role="img" aria-label="Carte stylisée des communes desservies autour de Valréas">
          <circle cx="400" cy="300" r="210" fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="1" strokeDasharray="4 6" />
          <circle cx="400" cy="300" r="120" fill="none" stroke="rgba(255,255,255,0.14)" strokeWidth="1" />
          <motion.circle
            cx="400" cy="300" r="26"
            fill="none" stroke="#E39A3B" strokeWidth="1"
            animate={{ r: [26, 52], opacity: [0.7, 0] }}
            transition={{ duration: 2.4, repeat: Infinity, ease: "easeOut" }}
          />
          <circle cx="400" cy="300" r="7" fill="#E39A3B" />
          <text
            x="400" y="338" textAnchor="middle"
            fill="#E39A3B" fontSize="30" fontStyle="italic"
            fontFamily="Cormorant Garamond, serif"
          >
            Valréas
          </text>
          {communes.map((c) => (
            <g key={c.name}>
              <circle cx={c.x} cy={c.y} r="3" fill="rgba(255,255,255,0.45)" />
              <text
                x={c.x} y={c.y - 12} textAnchor="middle"
                fill="#9AA7B4" fontSize="13" letterSpacing="2"
                fontFamily="Outfit, sans-serif"
                style={{ textTransform: "uppercase" }}
              >
                {c.name.toUpperCase()}
              </text>
            </g>
          ))}
        </svg>
      </motion.div>
    </div>
  </section>
);
